let allProducts = [];
let selectedProducts = []; // Array to allow multiple products

// Estado do catalogo. O dropdown precisa distinguir "ainda nao chegou" de "nao
// existe": o fetch do catalogo leva ~1,3s e, sem isso, quem digita nesse intervalo
// le "Nenhum produto encontrado" e conclui que o produto dele nao e registravel.
const CATALOG_LOADING = 'loading';
const CATALOG_READY = 'ready';
const CATALOG_ERROR = 'error';
let catalogStatus = CATALOG_LOADING;

document.addEventListener('DOMContentLoaded', () => {
    fetchProducts().then(() => {
        // Hydrate from localStorage JSON after products are loaded
        loadSavedProducts();
        checkUrlParamsAndSelectProduct();
        // O catalogo pode chegar depois de o cliente ja ter digitado: refaz a busca
        // aberta para trocar o "Carregando catalogo..." pelo resultado real.
        refreshOpenDropdown();
    });
    setupAutocomplete();
});

async function fetchProducts() {
    const apiUrl = 'https://api.dorel.com.br/v1/catalog/product_assistances';
    const fallbackUrl = 'assets/data/products.json';

    try {
        let response = await fetch(apiUrl);
        if (!response.ok) throw new Error('API CORS or Network error');
        let data = await response.json();
        processProducts(data);
    } catch (e) {
        console.warn('API Dorel failed, using local fallback JSON.', e);
        try {
            let response = await fetch(fallbackUrl);
            let data = await response.json();
            processProducts(data);
        } catch (fallbackError) {
            catalogStatus = CATALOG_ERROR;
            console.error('Fatal: Could not load products from API nor fallback.', fallbackError);
        }
    }
}
/*async function fetchProducts() {
    const apiUrl = 'https://proxy-registro.vercel.app/api/proxy/v1/catalog/product_assistances';

    try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error(`API error: ${response.status}`);
        const data = await response.json();
        processProducts(data);
    } catch (e) {
        console.error('Fatal: Could not load products from API.', e);
    }
}*/

function processProducts(data) {
    if (!data || !Array.isArray(data)) {
        catalogStatus = CATALOG_ERROR;
        return;
    }

    // Filter by the brand name from configuration.
    // Sem marca resolvida nao ha default de marca: falha fechado (lista vazia)
    // em vez de assumir uma marca e vazar catalogo de outra loja.
    const brandName = (window.currentBrand?.brand_name || '').trim();
    if (!brandName) {
        allProducts = [];
        productSearchEntries = [];
        // Nao e "zero resultados": o catalogo chegou, mas a loja nao tem marca
        // resolvida, entao buscar qualquer coisa aqui e impossivel.
        catalogStatus = CATALOG_ERROR;
        console.warn('[API] Marca nao configurada (window.currentBrand.brand_name). Nenhum produto carregado.');
        return;
    }

    // Perform loose match just in case "Maxi Cosi" vs "Maxi-Cosi"
    allProducts = data.filter(p => {
        if (!p.brand_name) return false;
        const normalizedItemBrand = p.brand_name.toLowerCase().replace(/[- ]/g, '');
        const normalizedConfigBrand = brandName.toLowerCase().replace(/[- ]/g, '');
        return normalizedItemBrand === normalizedConfigBrand;
    });

    // Indice de busca montado uma vez por carga do catalogo (ver searchProducts)
    productSearchEntries = buildSearchEntries(allProducts);
    catalogStatus = CATALOG_READY;

    console.log(`[API] Loaded ${allProducts.length} products for brand ${brandName}`);
}

/**
 * Deriva as flags de garantia a partir do produto.
 * Regras:
 *  - O caractere '+' na string `warranty` indica que existe garantia estendida
 *    (algo além da garantia padrão).
 *  - O caractere '*' indica que a garantia estendida depende do cadastro do selo.
 *  - O input de número do selo só é exigido quando `guarantee_seal` é true
 *    E a `warranty` contém '+' e '*'.
 */
function getWarrantyFlags(product) {
    const warrantyText = product.warranty || '';
    const hasExtendedWarranty = warrantyText.includes('+'); // '+' => garantia além da padrão
    const hasSealMarker = warrantyText.includes('*');       // '*' => exige cadastro de selo

    return {
        hasExtendedWarranty,
        hasSealMarker,
        // Caso 1: selo verde (estendida) + input habilitado + texto extra
        requiresSeal: product.guarantee_seal === true && hasExtendedWarranty && hasSealMarker,
        // Selo verde sempre que houver garantia estendida (presença de '+')
        isExtended: hasExtendedWarranty,
    };
}

// ---------------------------------------------------------------------------
// Busca de produtos (nome, referência, categoria e sinônimos)
//
// O cliente raramente digita só o nome do catálogo: ele escreve a categoria antes
// ("Carrinho de Bebê Trino", "Canguru Bang") ou usa o apelido do dia a dia
// ("cadeirinha", "conchinha", "cadeirão"). A busca antiga olhava apenas `name` e
// `reference`, então qualquer palavra a mais zerava a lista.
//
// Agora cada produto ganha um "haystack" com nome + referência + categoria + os
// sinônimos daquela categoria, e a consulta é quebrada em palavras que precisam
// TODAS aparecer nesse haystack (AND). Assim "carrinho trino" continua achando o
// Trino sem que "carrinho" sozinho vire ruído, e "canguru" traz a categoria
// inteira. Tudo é comparado sem acento, porque ninguém digita "Bebê Conforto"
// com o circunflexo no lugar certo.
// ---------------------------------------------------------------------------

// Teto de itens exibidos no dropdown: "carrinho" casa com mais de cem produtos e
// não adianta despejar todos numa lista de 240px de altura.
const MAX_SEARCH_RESULTS = 50;

// O debounce aqui NÃO protege rede: a busca é local (~0,05ms) e o catálogo é
// baixado uma única vez no load. O que ele evita é remontar até 50 nós do dropdown
// a cada tecla. Por isso 100ms — o suficiente para agrupar teclas de uma digitação
// contínua sem a espera perceptível que 300ms causava.
const SEARCH_DEBOUNCE_MS = 100;

// Conectores são descartados da consulta para que "cadeirinha de carro" não
// dependa de o haystack conter exatamente o "de".
const SEARCH_STOPWORDS = ['de', 'da', 'do', 'das', 'dos', 'para', 'pra', 'com', 'e', 'em', 'no', 'na', 'o', 'a', 'os', 'as', 'um', 'uma'];

// Sinônimos por categoria do catálogo (chave = valor exato de `category` na API).
// Termos repetidos entre categorias são intencionais: quem busca "cadeirinha"
// espera ver tanto Cadeira para Auto quanto Bebê Conforto.
//
// Só o singular entra: `reduzirPlural` cuida do "carrinhos", e o nome da própria
// categoria já está no índice. A exceção é o plural em -l ("móvel"/"móveis"), que
// nenhuma regra simples resolve.
const CATEGORY_SYNONYMS = {
    'Carrinho de Bebê': ['carrinho', 'carrinho de bebe', 'carriola', 'buggy', 'stroller', 'passeio'],
    'Travel System': ['travel system', 'carrinho', 'carrinho com bebe conforto', 'conjunto', 'trio', 'duo', 'bebe conforto', 'cadeirinha'],
    'Cadeira para Auto': ['cadeira para auto', 'cadeira auto', 'cadeirinha', 'cadeirinha de carro', 'cadeira de carro', 'assento infantil', 'poltrona', 'car seat'],
    'Bebê Conforto': ['bebe conforto', 'conchinha', 'concha', 'ovinho', 'ovo', 'cadeirinha', 'cadeira para auto', 'car seat'],
    'Base para Veículo': ['base', 'base isofix', 'isofix', 'base para carro', 'base veicular'],
    'Berço Portátil': ['berco portatil', 'berco', 'mini berco', 'bercinho', 'chiqueirinho', 'cercado', 'playard', 'berco desmontavel'],
    'Moisés': ['moises', 'berco', 'bercinho', 'ninho', 'cesto'],
    'Cercado': ['cercado', 'cercadinho', 'chiqueirinho', 'piscina de bolinhas', 'playard'],
    'Canguru': ['canguru', 'sling', 'baby carrier', 'porta bebe', 'carregador de bebe', 'wrap', 'mochila canguru'],
    'Cadeira de Refeição': ['cadeira de refeicao', 'cadeirao', 'cadeira de alimentacao', 'cadeira alta', 'cadeira de comer', 'cadeira de papinha', 'high chair'],
    'Cadeira de Refeição Portátil': ['cadeira de refeicao portatil', 'cadeirao portatil', 'assento de refeicao', 'cadeira de comer portatil', 'booster'],
    'Cadeiras de Descanso - Bouncer': ['bouncer', 'cadeira de descanso', 'cadeirinha de descanso', 'espreguicadeira', 'balanco', 'cadeira vibratoria'],
    'Jumper': ['jumper', 'pula pula', 'saltador'],
    'Andador': ['andador', 'andaja', 'primeiros passos'],
    'Banheira': ['banheira', 'banho', 'banheira de bebe', 'ofuro'],
    'Acessório para Banho': ['acessorio para banho', 'banho', 'banheira', 'redutor de banheira', 'suporte de banho'],
    'Acessório para Higiene': ['acessorio para higiene', 'higiene', 'trocador', 'fralda', 'penico'],
    'Higiene e Saúde': ['higiene', 'saude', 'termometro', 'aspirador nasal', 'cortador de unha'],
    'Troninhos e Redutores': ['troninho', 'penico', 'redutor', 'redutor de assento', 'assento sanitario', 'desfralde'],
    'Babá Eletrônica': ['baba eletronica', 'baba', 'monitor', 'monitor de bebe', 'intercomunicador', 'camera'],
    'Tapete de Atividades': ['tapete de atividades', 'tapete', 'tapetinho', 'ginasio', 'ginasio de atividades', 'playmat'],
    'Centro de Atividades': ['centro de atividades', 'atividades', 'mesa de atividades'],
    'Móbiles': ['mobile', 'movel de berco', 'musical', 'carrossel'],
    'Projetores': ['projetor', 'luminaria', 'luz noturna', 'sonoro'],
    'Brinquedos': ['brinquedo', 'toy', 'pelucia', 'chocalho', 'mordedor'],
    'Bolsa | Mochila': ['bolsa', 'mochila', 'bolsa maternidade', 'bolsa de bebe', 'mala', 'sacola'],
    'Kit Decorativo': ['kit decorativo', 'decoracao', 'kit berco', 'enxoval'],
    'Móveis': ['movel', 'comoda', 'guarda roupa', 'estante', 'criado mudo', 'mesa'], // 'moveis' já vem do nome da categoria
    'Beachwear': ['beachwear', 'praia', 'piscina', 'boia', 'roupa de praia', 'protecao solar'],
    'Acessórios de Segurança': ['acessorio de seguranca', 'seguranca', 'protetor', 'trava', 'grade', 'portao', 'protetor de tomada'],
    'Acessório Veicular': ['acessorio veicular', 'veicular', 'carro', 'protetor de banco', 'espelho retrovisor', 'quebra sol'],
    'Acessório para Carrinho': ['acessorio para carrinho', 'carrinho', 'capa de chuva', 'capota', 'adaptador', 'bandeja', 'saco de dormir'],
    'Acessório para Alimentação': ['acessorio para alimentacao', 'alimentacao', 'mamadeira', 'prato', 'copo', 'talher', 'babador', 'papinha', 'chupeta'],
    'Acessório': ['acessorio', 'peca', 'peca de reposicao', 'reposicao']
};

// Minúsculas, sem acento e sem pontuação: "Bebê Conforto" e "bebe-conforto" viram
// a mesma coisa, e a referência "CD200TS" continua casando com "cd200ts".
function normalizeSearchText(value) {
    return (value == null ? '' : String(value))
        .normalize('NFD')
        .replace(/\p{M}/gu, '') // NFD separa o acento da letra; \p{M} remove o acento
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}

// Sinônimos já normalizados e indexados pela categoria normalizada, montados uma
// vez só em vez de a cada tecla digitada.
const CATEGORY_SYNONYMS_INDEX = Object.keys(CATEGORY_SYNONYMS).reduce((index, category) => {
    index[normalizeSearchText(category)] = CATEGORY_SYNONYMS[category].map(normalizeSearchText).join(' ');
    return index;
}, {});

// Índice de busca mantido fora dos objetos de produto: o produto selecionado é
// serializado no localStorage e no payload de envio, e não precisa carregar isso.
let productSearchEntries = [];

function buildSearchEntries(products) {
    return products.map(product => {
        const name = normalizeSearchText(product.name);
        const reference = normalizeSearchText(product.reference);
        const category = normalizeSearchText(product.category);
        const synonyms = CATEGORY_SYNONYMS_INDEX[category] || '';

        return {
            product,
            name,
            reference,
            category,
            haystack: [name, reference, category, synonyms].filter(Boolean).join(' ')
        };
    });
}

// Plural do português: "berços" -> "berco", "projetores" -> "projetor".
// Reduzir o termo digitado só pode AUMENTAR o que casa, porque a forma curta é
// prefixo da longa e a comparação é por substring — nenhuma busca que funcionava
// deixa de funcionar. Por isso a redução vale a pena mesmo sendo imperfeita: ela
// não acerta plural em -l ("móveis" -> "movel"), e esses poucos casos continuam
// resolvidos por sinônimo escrito à mão.
function reduzirPlural(token) {
    // Token com dígito é referência/SKU, não palavra: "CD200TS" reduzido virava
    // "cd200t" e passava a casar também com o CD200TRIO, ou seja, quem digitava a
    // referência exata do Duo recebia o Trio junto.
    if (/\d/.test(token)) return token;

    if (token.length >= 6 && token.slice(-2) === 'es') return token.slice(0, -2);
    if (token.length >= 5 && token.slice(-1) === 's') return token.slice(0, -1);
    return token;
}

function tokenizeQuery(query) {
    const tokens = normalizeSearchText(query).split(' ').filter(Boolean);
    const meaningful = tokens.filter(token => SEARCH_STOPWORDS.indexOf(token) === -1);
    // "de" sozinho ainda é uma busca: só descarta os conectores quando sobra algo.
    const usados = meaningful.length > 0 ? meaningful : tokens;
    return usados.map(reduzirPlural);
}

// Ordena do mais direto para o mais amplo: quem digitou "trino" quer o Trino no
// topo, não os acessórios cuja categoria também casou.
//
// A distinção entre os dois últimos níveis importa porque há sinônimo que cruza
// categoria de propósito ("cadeirinha" e "cadeira para auto" também apontam para
// Bebê Conforto, que é uma cadeirinha de grupo 0+). Sem separar, quem digitava o
// nome exato de uma categoria via itens de OUTRA categoria furando a fila no meio
// da lista. Categoria literal primeiro deixa o dropdown se explicar sozinho: os
// primeiros itens mostram a categoria que a pessoa digitou, e o cruzamento vem
// depois, como um "veja também".
function scoreEntry(entry, tokens) {
    const query = tokens.join(' ');
    const inName = (token) => entry.name.indexOf(token) !== -1;
    const inReference = (token) => entry.reference.indexOf(token) !== -1;
    const inCategory = (token) => entry.category.indexOf(token) !== -1;

    if (entry.reference && entry.reference.indexOf(query) === 0) return 6;
    if (entry.name.indexOf(query) === 0) return 5;
    if (tokens.every(inName)) return 4;
    if (tokens.every(token => inName(token) || inReference(token))) return 3;
    if (tokens.every(token => inName(token) || inReference(token) || inCategory(token))) return 2;
    return 1; // casou só por sinônimo — inclusive sinônimo de outra categoria
}

function searchProducts(query) {
    const tokens = tokenizeQuery(query);
    if (tokens.length === 0) return [];

    const matches = [];
    productSearchEntries.forEach(entry => {
        if (!tokens.every(token => entry.haystack.indexOf(token) !== -1)) return;
        matches.push({ entry, score: scoreEntry(entry, tokens) });
    });

    // sort estável: dentro do mesmo score vale a ordem do catálogo
    matches.sort((a, b) => b.score - a.score);
    return matches.map(match => match.entry.product);
}

function setupAutocomplete() {
    const searchInput = document.getElementById('productSearch');
    const dropdown = document.getElementById('productDropdown');

    if (!searchInput || !dropdown) return;

    let debounceTimer;

    searchInput.addEventListener('input', (e) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            const query = e.target.value.trim();
            if (query.length < 2) {
                dropdown.classList.add('hidden');
                return;
            }

            renderDropdown(searchProducts(query));
        }, SEARCH_DEBOUNCE_MS);
    });

    // Close dropdown on outside click
    document.addEventListener('click', (e) => {
        if (!searchInput.contains(e.target) && !dropdown.contains(e.target)) {
            dropdown.classList.add('hidden');
        }
    });

    // Make sure click on input with value opens it
    searchInput.addEventListener('focus', (e) => {
        if (e.target.value.trim().length >= 2) {
            searchInput.dispatchEvent(new Event('input'));
        }
    });
}

// Refaz a busca que já está na tela, sem exigir uma tecla nova do cliente.
function refreshOpenDropdown() {
    const searchInput = document.getElementById('productSearch');
    const dropdown = document.getElementById('productDropdown');

    if (!searchInput || !dropdown) return;
    if (dropdown.classList.contains('hidden')) return;
    if (searchInput.value.trim().length < 2) return;

    searchInput.dispatchEvent(new Event('input'));
}

// Lista vazia tem três causas diferentes, e tratar as três como "não encontrado"
// faz o cliente desistir achando que o produto dele não pode ser registrado.
function mensagemListaVazia() {
    if (catalogStatus === CATALOG_LOADING) {
        return 'Carregando catálogo de produtos...';
    }
    if (catalogStatus === CATALOG_ERROR) {
        return 'Não foi possível carregar o catálogo. Recarregue a página ou use o QR Code do selo de garantia.';
    }
    return 'Nenhum produto encontrado.';
}

function renderDropdown(matches) {
    const dropdown = document.getElementById('productDropdown');
    dropdown.innerHTML = '';

    if (matches.length === 0) {
        const aviso = document.createElement('div');
        aviso.className = 'p-4 text-sm text-gray-500';
        aviso.textContent = mensagemListaVazia();
        dropdown.appendChild(aviso);
        dropdown.classList.remove('hidden');
        return;
    }

    // Buscar por categoria ("carrinho") pode casar com o catalogo quase inteiro:
    // corta a lista e avisa, em vez de montar centenas de nos no dropdown.
    const results = matches.slice(0, MAX_SEARCH_RESULTS);

    results.forEach(product => {
        const item = document.createElement('div');
        item.className = 'p-3 hover:bg-brand-primary/5 cursor-pointer border-b border-gray-100 last:border-0 transition-colors flex flex-col';

        // Montado como nós em vez de innerHTML: `name`, `reference` e `category` vêm
        // do catálogo da API, e um '<' em qualquer um deles quebrava o dropdown em
        // silêncio. Mesma marcação de antes — as classes e o aninhamento não mudam.
        const linhaNome = document.createElement('span');
        linhaNome.className = 'font-bold text-brand-primary text-sm';
        linhaNome.textContent = `${product.name || ''} `;

        const referencia = document.createElement('span');
        referencia.className = 'text-gray-400 font-normal';
        referencia.textContent = `(${product.reference || 'N/A'})`;
        linhaNome.appendChild(referencia);

        const linhaCategoria = document.createElement('span');
        linhaCategoria.className = 'text-xs text-gray-500';
        linhaCategoria.textContent = product.category || 'Geral';

        item.appendChild(linhaNome);
        item.appendChild(linhaCategoria);

        item.addEventListener('click', () => {
            selectProduct(product);
        });
        dropdown.appendChild(item);
    });

    if (matches.length > results.length) {
        const note = document.createElement('div');
        note.className = 'p-3 text-xs text-gray-500 bg-gray-50 border-t border-gray-100 sticky bottom-0';
        note.textContent = `Mostrando ${results.length} de ${matches.length} produtos. Digite o nome ou a referência para refinar a busca.`;
        dropdown.appendChild(note);
    }

    dropdown.classList.remove('hidden');
}

function selectProduct(product, preselectedSku = null) {
    // Add unique internal ID to manage selection
    const productEntry = {
        _id: Date.now().toString(),
        ...product,
        selectedColorIndex: null, // to be picked
        warrantyCode: '' // to be typed
    };

    // Auto-select color if only one item available
    const validItems = Array.isArray(product.items) ? product.items : [];
    if (preselectedSku) {
        const idx = validItems.findIndex(i => i.sku === preselectedSku);
        if (idx !== -1) productEntry.selectedColorIndex = idx;
    } else if (validItems.length === 1) {
        productEntry.selectedColorIndex = 0;
    }

    selectedProducts.push(productEntry);

    const searchInput = document.getElementById('productSearch');
    const dropdown = document.getElementById('productDropdown');
    searchInput.value = ''; // clear for next search
    dropdown.classList.add('hidden');

    saveSelectedProductsToInput();
    renderSelectedProducts();
}

window.removeProduct = function (id) {
    selectedProducts = selectedProducts.filter(p => p._id !== id);
    saveSelectedProductsToInput();
    renderSelectedProducts();
};

window.clearSelectedProducts = function () {
    selectedProducts = [];
    saveSelectedProductsToInput();
    renderSelectedProducts();
};

window.updateProductMetadata = function (id, key, value) {
    const p = selectedProducts.find(x => x._id === id);
    if (p) {
        p[key] = value;
        saveSelectedProductsToInput();

        if (key === 'selectedColorIndex') {
            // Re-render to update the image preview based on color
            renderSelectedProducts();
        }
    }
};

function saveSelectedProductsToInput() {
    const input = document.getElementById('selected_products_json');
    if (input) {
        input.value = JSON.stringify(selectedProducts);
        // Dispatch event so form.js logic picks it up on state save boundaries
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        if (typeof saveFormState === 'function') saveFormState();
    }
}

function loadSavedProducts() {
    const rawState = localStorage.getItem('dorel_registration_state');
    if (rawState) {
        try {
            const state = JSON.parse(rawState);
            if (state.selected_products_json) {
                const parsed = JSON.parse(state.selected_products_json);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    selectedProducts = parsed;
                    renderSelectedProducts();
                    return;
                }
            }
        } catch (e) {
            console.error('Failed to parse saved registration state', e);
        }
    }

    const input = document.getElementById('selected_products_json');
    if (input && input.value && input.value !== '[]') {
        try {
            selectedProducts = JSON.parse(input.value);
            renderSelectedProducts();
        } catch (e) {
            console.error('Failed to parse hydrated products JSON', e);
        }
    }
}

window.formatWarrantyObject = function (input, productId) {
    let value = input.value.replace(/\D/g, '');
    if (value.length > 9) value = value.slice(0, 9);
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    input.value = value;
    updateProductMetadata(productId, 'warrantyCode', value);
}

function checkUrlParamsAndSelectProduct() {
    const params = new URLSearchParams(window.location.search);
    const prd = params.get('prd');
    const skuParam = params.get('sku');
    const code = params.get('code');

    let modified = false;

    if (prd) {
        const found = allProducts.find(p => p.id === prd);
        if (found && !selectedProducts.some(sp => sp.id === found.id)) {
            selectProduct(found, null);
            modified = true;
        }
    }

    if (skuParam) {
        const skus = skuParam.split(',').map(s => s.trim()).filter(s => s);

        skus.forEach(sku => {
            const found = allProducts.find(p => {
                if (Array.isArray(p.items)) {
                    return p.items.some(i => i.sku === sku);
                }
                return false;
            });

            if (found && !selectedProducts.some(sp => sp.id === found.id)) {
                // selectProduct automatically handles inserting it to the array
                selectProduct(found, sku);
                modified = true;

                // If there's a warranty code, apply it only when the product actually
                // requires a seal (guarantee_seal true + warranty com '+' e '*').
                const { requiresSeal } = getWarrantyFlags(found);
                if (code && requiresSeal) {
                    const addedProductIndex = selectedProducts.length - 1;
                    const addedProduct = selectedProducts[addedProductIndex];

                    // Format the code
                    let formattedCode = code.replace(/\D/g, '');
                    if (formattedCode.length > 9) formattedCode = formattedCode.slice(0, 9);
                    formattedCode = formattedCode.replace(/(\d{3})(\d)/, '$1.$2');
                    formattedCode = formattedCode.replace(/(\d{3})(\d)/, '$1.$2');

                    addedProduct.warrantyCode = formattedCode;
                    saveSelectedProductsToInput();
                    renderSelectedProducts();
                }
            }
        });
    }

    if (modified) {
        const url = new URL(window.location);
        url.search = '';
        window.history.replaceState({}, document.title, url);
    }
}

function renderSelectedProducts() {
    const container = document.getElementById('selectedProductsList');
    if (!container) return;

    const tipsSection = document.getElementById('tipsSection');
    if (tipsSection) {
        if (selectedProducts.length > 0) {
            tipsSection.classList.remove('hidden');
        } else {
            tipsSection.classList.add('hidden');
        }
    }

    container.innerHTML = '';

    selectedProducts.forEach(p => {
        const validItems = Array.isArray(p.items) ? p.items : [];
        const colorItem = (p.selectedColorIndex !== null && validItems[p.selectedColorIndex]) ? validItems[p.selectedColorIndex] : (validItems.length > 0 ? validItems[0] : null);

        // Flags de garantia centralizadas
        const { requiresSeal, isExtended } = getWarrantyFlags(p);

        let imageUrl = '';
        if (colorItem && colorItem.image_url) {
            imageUrl = colorItem.image_url;
        }

        const card = document.createElement('div');
        card.className = "bg-white border border-gray-200 rounded-2xl p-6 md:p-8 relative shadow-sm flex flex-col gap-6 w-full mt-2";

        let html = `
            <button type="button" class="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-red-100 text-red-600 hover:bg-red-200 transition-colors flex items-center justify-center font-bold text-sm shadow-md z-10" onclick="removeProduct('${p._id}')" title="Remover Produto">
                X
            </button>
        `;

        html += `<div class="flex flex-col md:flex-row gap-8 items-start w-full">`;

        html += `
            <div class="w-full md:w-48 h-48 bg-white rounded-xl border border-gray-100 p-4 flex items-center justify-center shrink-0 shadow-sm relative">
               ${imageUrl ? `<img src="${imageUrl}" alt="Produto" class="w-full h-full object-contain">` : `<div class="w-full h-full bg-gray-50 flex items-center justify-center text-gray-300 rounded"><svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg></div>`}
            </div>
        `;

        html += `<div class="flex flex-col gap-1 w-full">`;

        // Badge de garantia:
        //  - Caso 1 (exige selo): verde "GARANTIA ESTENDIDA APLICÁVEL"
        //  - Caso 2 (estendida sem selo): verde "GARANTIA ESTENDIDA"
        //  - Demais (sem '+'): amarelo "GARANTIA PADRÃO"
        const extendedBadgeText  = 'GARANTIA ESTENDIDA APLICÁVEL';
        html += `
          <div class="flex flex-row justify-between items-start w-full gap-4 mb-1">
             <span class="text-xs uppercase tracking-widest text-[var(--accent)] font-bold mt-1">${p.category || 'Categoria'}</span>
             ${isExtended ?
                `<div class="px-3 py-1 bg-[#d1fad8] text-[#0f5c2e] font-bold uppercase text-[10px] md:text-xs rounded-full flex items-center gap-1 shrink-0"><svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg> ${extendedBadgeText}</div>` :
                `<div class="px-3 py-1 bg-[#fdf2e3] text-[#b88c47] font-bold uppercase text-[10px] md:text-xs rounded-full flex items-center gap-1 shrink-0"><svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg> GARANTIA PADRÃO</div>`
            }
          </div>
        `;
 
        // Quantidade de meses (campo warranty) ACIMA do título — para todos os casos, texto reduzido.
        if (p.warranty) {
            html += `<p class="text-[11px] md:text-xs text-gray-500 font-medium mt-1 leading-snug">${p.warranty}</p>`;
        }
 
        // Informativo logo abaixo dos meses — para todos os casos.
        //  - Com garantia estendida ('+'): aplicável mediante registro do produto
        //  - Sem garantia estendida: produto não elegível
        const warrantyNote = isExtended
            ? '*Garantia estendida aplicável mediante registro do produto'
            : '*Produto não elegível a garantia estendida';
        html += `
          <p class="text-[10px] md:text-[11px] text-gray-400 mt-0.5 leading-snug">
            ${warrantyNote}
          </p>
        `;
 

        // Título do produto
        html += `<h3 class="font-display text-2xl md:text-3xl text-[var(--primary)] font-bold mt-2 mb-3">${p.name} <span class="text-base font-normal text-gray-500">(${p.reference || ''})</span></h3>`;

        if (validItems.length > 1) {
            let optionsHtml = `<option value="" disabled ${p.selectedColorIndex === null ? 'selected' : ''}>Selecione a cor...</option>`;
            validItems.forEach((c, idx) => {
                optionsHtml += `<option value="${idx}" ${p.selectedColorIndex == idx ? 'selected' : ''}>${c.sku} - ${c.color_name}</option>`;
            });

            html += `
              <div class="mt-2 flex flex-col gap-1.5 relative max-w-sm w-full">
                 <label class="font-semibold text-[var(--primary)] text-sm text-left">Cor do Produto</label>
                 <select class="w-full text-[var(--primary)] border border-gray-300 rounded-lg h-12 pl-4 pr-10 appearance-none bg-white focus:outline-none focus:border-[var(--primary)] font-medium text-sm"
                    onchange="updateProductMetadata('${p._id}', 'selectedColorIndex', this.value)">
                    ${optionsHtml}
                 </select>
                 <div class="absolute inset-y-0 right-0 top-6 flex items-center pr-4 pointer-events-none text-gray-500">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path></svg>
                 </div>
              </div>
            `;
        } else if (validItems.length === 1) {
            html += `<p class="text-gray-500 font-medium text-sm mt-1">Cor: ${validItems[0].color_name}</p>`;
        }

        let linkBtns = '';
        if (p.youtube_code) {
            linkBtns += `
             <button type="button" onclick="openVideoModal('${p.youtube_code}')" class="bg-[var(--primary)] text-white text-sm font-semibold rounded-lg px-6 h-11 flex items-center gap-2 hover:bg-[var(--primary-dark)] transition-colors">
               <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
               Vídeo
             </button>
           `;
        }

        if (p.manuals && Array.isArray(p.manuals) && p.manuals.length > 0) {
            const manualsEncoded = encodeURIComponent(JSON.stringify(p.manuals));
            linkBtns += `
             <button type="button" onclick="openManualsModal('${manualsEncoded}')" class="bg-[var(--primary)] text-white text-sm font-semibold rounded-lg px-6 h-11 flex items-center gap-2 hover:bg-[var(--primary-dark)] transition-colors">
               <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
               Manuais
             </button>
           `;
        }

        if (linkBtns !== '') {
            html += `<div class="flex flex-wrap gap-4 mt-5 w-full justify-start">${linkBtns}</div>`;
        }

        html += `</div>`;
        html += `</div>`;

        // Input do selo: somente quando o produto exige cadastro de selo (Caso 1)
        if (requiresSeal) {
            html += `
            <div class="mt-2 pt-6 border-t border-gray-100 flex flex-col gap-2 relative">
              <label class="font-semibold text-[var(--primary)] text-sm flex items-center gap-2">
                Número do Selo de Garantia
                <span title="Normalmente na base do produto." class="text-gray-400 cursor-help flex items-center gap-1 font-normal text-xs mb-0.5">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                </span>
              </label>
              <input type="text" placeholder="Ex: 991.903.532" maxlength="11"
                class="w-full font-mono text-base tracking-wider border border-gray-300 rounded-lg p-3 bg-white focus:outline-none focus:border-brand-primary h-12" 
                value="${p.warrantyCode || ''}"
                oninput="formatWarrantyObject(this, '${p._id}')">
            </div>
            `;
        }

        card.innerHTML = html;
        container.appendChild(card);
    });
}

// `advance` controla se, ao passar na validação, avança para o Passo 2.
//  - true  (padrão): usado pelo botão "Avançar Passo" do Passo 1.
//  - false: usado no submit apenas para checar a etapa sem navegar adiante.
// Retorna `true` quando a etapa é válida e `false` quando há erro.
window.validateStep1 = function (advance = true) {
    const errorDiv = document.getElementById('step1Error');
    const showError = (msg) => {
        if (!errorDiv) return;
        errorDiv.textContent = msg;
        errorDiv.classList.remove('hidden');
    };

    if (errorDiv) errorDiv.classList.add('hidden');

    if (selectedProducts.length === 0) {
        showError("Por favor, busque e selecione pelo menos um produto para continuar.");
        return false;
    }

    for (let p of selectedProducts) {
        // Só exige o selo quando o produto realmente o requer (mesma regra do render)
        const { requiresSeal } = getWarrantyFlags(p);
        if (requiresSeal && (!p.warrantyCode || p.warrantyCode.trim().length < 5)) {
            showError("O preenchimento do Selo de Garantia é obrigatório para o produto: " + p.name);
            // Optionally, scroll to the card: document.getElementById('selectedProductsList').scrollIntoView({ behavior: 'smooth' })
            return false;
        }

        let validItems = Array.isArray(p.items) ? p.items : [];
        if (validItems.length > 1 && p.selectedColorIndex === null) {
            showError("Por favor, selecione a cor do produto: " + p.name);
            return false;
        }
    }

    // Move to next step via main.js (somente quando acionado pelo botão "Avançar Passo")
    if (advance) {
    if (typeof nextStep === 'function') nextStep(2);
    else console.error("Global nextStep not found.");
        }
    return true;
}

// Global Modal Handlers
window.openVideoModal = function (code) {
    const modal = document.getElementById('modalGeneric');
    const title = document.getElementById('modalGenericTitle');
    const content = document.getElementById('modalGenericContent');

    title.textContent = 'Vídeo do Produto';
    content.innerHTML = `<iframe class="w-full h-[50vh] md:h-[70vh]" src="https://www.youtube.com/embed/${code}?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;

    modal.classList.remove('hidden');
    modal.classList.add('flex');
}

window.openManualsModal = function (manualsStr) {
    const manuals = JSON.parse(decodeURIComponent(manualsStr));
    const modal = document.getElementById('modalGeneric');
    const title = document.getElementById('modalGenericTitle');
    const content = document.getElementById('modalGenericContent');

    title.textContent = 'Manuais Disponíveis';

    let html = '<div class="p-4 md:p-6 flex flex-col gap-4">';
    manuals.forEach(m => {
        html += `<a href="${m.url}" target="_blank" class="p-4 bg-white border border-gray-200 rounded-xl hover:border-brand-primary flex justify-between items-center group transition-colors shadow-sm">
            <span class="font-semibold text-brand-primary group-hover:text-brand-accent">${m.name || 'Baixar Manual'}</span>
            <svg class="w-5 h-5 text-gray-400 group-hover:text-brand-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>
        </a>`;
    });
    html += '</div>';

    content.innerHTML = html;
    modal.classList.remove('hidden');
    modal.classList.add('flex');
}

window.closeGenericModal = function () {
    const modal = document.getElementById('modalGeneric');
    modal.classList.add('hidden');
    modal.classList.remove('flex');
    document.getElementById('modalGenericContent').innerHTML = ''; // wipe iframe to stop play
}